import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-app-layout>` creates the app layout with header-bar, main-content
 * and footer regions
 */
@Component({
  selector: 'labs-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppLayoutComponent {}
